import { Box } from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

/** @param {typeof propTypes} props  */
function Title(props) {
    const { size = 'lg', color = 'dark', underline = false } = props;

    return (
        <Box
            className={classNames(props.className, styles[`size-${size}`], styles[`color-${color}`], {
                [styles[`theme-${props.theme}`]]: props.theme,
                [styles.bolder]: props.bolder,
                [styles.bold]: props.bold,
                [styles.italic]: props.italic,
                [styles.underline]: underline,
                [styles[`align-${props.align}`]]: props.align,
            })}
            onClick={props.onClick}
            sx={props.sx}
        >
            {props.children}
        </Box>
    );
}

const propTypes = {
    size: PropTypes.oneOf(['xxl', 'xl', 'lg', 'md', 'sm', 'xs']),
    color: PropTypes.oneOf([
        'dark',
        'light',
        'white',
        'primary',
        'secondary',
        'primary-corn',
        'primary-soy',
        'primary-refuge',
        'primary-corn-light-1',
        'primary-soy-light-1',
        'primary-dark-2',
        'primary-crop_protection',
        'primary-crop_protection-light-1',
        'no-selected',
        'gray-light',
        'gray-dark',
        'green',
        'error',
        'red',
    ]),
    underline: PropTypes.bool,
    bolder: PropTypes.bool,
    bold: PropTypes.bool,
    italic: PropTypes.bool,
    className: PropTypes.string,
    align: PropTypes.oneOf(['center', 'justify', 'right', 'left', 'start', 'end']),
    theme: PropTypes.oneOf(['latijereta', 'cultivio', 'agroceres', 'agroeste', 'expertobayer', 'md', 'fieldview']),
    onClick: PropTypes.func,
};

Title.propTypes = propTypes;
export default Title;
